import React, { useRef, useState } from 'react';
import html2canvas from 'html2canvas';

const Quote = ({ quote, liked = false, onLike, onShare }) => {
    const quoteCardRef = useRef(null);
    const [imageError, setImageError] = useState(null);
    const [downloading, setDownloading] = useState(false);
    const [copyStatus, setCopyStatus] = useState('');
    const copyTimerRef = useRef(null);

    const handleShareAsImage = async () => {
        setImageError(null);
        setDownloading(true);
        try {
            const canvas = await html2canvas(quoteCardRef.current, {
                useCORS: true,
                scale: 2,
                backgroundColor: '#141b27',
                logging: false,
            });
            const link = document.createElement('a');
            link.href = canvas.toDataURL('image/png');
            const slug = quote.author
                ? quote.author.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')
                : 'quote';
            link.download = `captions-${slug}.png`;
            link.click();
        } catch (err) {
            console.error('Failed to generate image:', err);
            setImageError('Could not generate image. Please try again.');
        } finally {
            setDownloading(false);
        }
    };

    const handleCopy = async () => {
        const text = `"${quote.text}" — ${quote.author}`;
        try {
            await navigator.clipboard.writeText(text);
            setCopyStatus('Copied!');
        } catch {
            setCopyStatus('Failed');
        }
        clearTimeout(copyTimerRef.current);
        copyTimerRef.current = setTimeout(() => setCopyStatus(''), 2500);
    };

    return (
        <div className="quote-card">
            <div className="quote-content" ref={quoteCardRef}>
                <p className="quote-text">{quote.text}</p>
                <p className="quote-author">{quote.author}</p>
                <span className="quote-watermark">captions.</span>
            </div>
            {imageError && <p className="error-text">{imageError}</p>}
            <div className="quote-actions">
                {onLike && (
                    <button
                        onClick={onLike}
                        className={liked ? 'liked' : ''}
                        aria-label={liked ? 'Unlike quote' : 'Like quote'}
                    >
                        {liked ? 'Liked' : 'Like'}
                    </button>
                )}
                <button onClick={handleCopy} aria-label="Copy quote to clipboard">
                    {copyStatus || 'Copy'}
                </button>
                {onShare && (
                    <button onClick={onShare} aria-label="Share quote as text">
                        Share
                    </button>
                )}
                <button
                    onClick={handleShareAsImage}
                    disabled={downloading}
                    aria-label="Download quote as image"
                >
                    {downloading ? 'Saving…' : 'Download'}
                </button>
            </div>
        </div>
    );
};

export default Quote;
